<template>
  <div>
    <b-navbar  toggleable="sm" type="dark"  variant="primary primaryGColor shadow">
      <b-navbar-brand to="/" class="d-none d-sm-block"><b-img :src="require('../assets/namelogo.svg')" fluid alt="姓名DNA" style="height: 1.3rem"></b-img> - <span style="font-size: 1rem;">姓名分析專家 <small>v1.5.4</small></span></b-navbar-brand>
      <b-navbar-nav >
        <b-nav-item class="d-block d-sm-none" v-b-toggle.sidebar-backdrop  >
          <b-icon icon="people-circle" style="font-size:2rem;color: #fff" ></b-icon>
          <span class="text-white ml-1">{{name}}</span>
        </b-nav-item>
      </b-navbar-nav>
      <b-sidebar id="sidebar-backdrop" v-model="show" no-header backdrop shadow width="250px" bg-variant="white" >
        <template v-slot:default="{hide}" >
          <div class="p-3 " >
            <b-link  @click="hide" class="h5"><b-icon icon="chevron-bar-left" ></b-icon></b-link>

            <div v-if="!isLogin" class="w-25 text-center mx-auto">
              <b-img :src="require('../assets/ui/userdefault.png')" fluid alt="Responsive image"  rounded="circle"></b-img>
            </div>
            <h6 v-if="!isLogin" class="text-center py-3">立即登入更多體驗</h6>
            <b-list-group class="border-0 list-group-flush ">
              <b-list-group-item @click="goTo('profile')" class="d-flex justify-content-between align-items-center">
                基本資料
                <b-icon icon="person-lines-fill" ></b-icon>
              </b-list-group-item>
              <b-list-group-item v-if="salesmodel" @click="goTo('Sales')"  class="d-flex justify-content-between align-items-center">
                業務專區
                <b-icon icon="briefcase-fill" ></b-icon>
              </b-list-group-item>
              <b-list-group-item v-if="true" to="/Payment/Plan"  class="d-flex justify-content-between align-items-center">
                會員方案
                <b-icon icon="gift-fill" ></b-icon>
              </b-list-group-item>

              <b-list-group-item @click="goTo('HistoryLog')"  class="d-flex justify-content-between align-items-center">
                比對紀錄
                <b-icon icon="clock-history" ></b-icon>
              </b-list-group-item>
              <b-list-group-item @click="goTo('MasterChat')"  class="d-flex justify-content-between align-items-center">
                大師對話
                <b-icon icon="chat-dots-fill" ></b-icon>
              </b-list-group-item>

              <b-list-group-item v-if="isLogin" @click="Logout" class="d-flex justify-content-between align-items-center">
                登出
              </b-list-group-item>
              <b-list-group-item v-if="!isLogin" to="/login" class="d-flex justify-content-between align-items-center">
                登入
              </b-list-group-item>
            </b-list-group>
          </div>
        </template>
      </b-sidebar>
      <b-navbar-nav  class="ml-auto " >
        <b-nav-item  v-if="!isLogin" to="/login" ><span class="text-light">登入</span></b-nav-item>
        <div v-else class="d-flex flex-row">


          <b-nav-item  class="  d-flex align-items-center ">

            <b-button  variant="danger" to="/Payment/Plan">
              <b-icon icon="gift-fill" style="color: #fff" ></b-icon> 購買方案
            </b-button>
          </b-nav-item>
          <b-dropdown size="md"  variant="link" toggle-class="pr-3 d-none d-sm-block text-decoration-none " no-caret right>
            <template v-slot:button-content>
              <b-icon icon="people-circle"  style="color: #fff"  ></b-icon><span class="text-white ml-1">{{ name }}</span>
            </template>
            <b-dropdown-item to="/profile">基本資料</b-dropdown-item>
            <b-dropdown-item v-if="salesmodel" to="/Sales">業務專區</b-dropdown-item>
            <b-dropdown-item v-if="true" to="/Payment/Plan">會員方案</b-dropdown-item>

            <b-dropdown-divider></b-dropdown-divider>
            <!--<b-dropdown-item to="/PaymentLog">購買紀錄</b-dropdown-item>-->
            <b-dropdown-item to="/HistoryLog">比對紀錄</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item to="/MasterChat">大師對話</b-dropdown-item>
            <!--<b-dropdown-item to="/Question">問題回報</b-dropdown-item>-->

            <!--<b-dropdown-item to="/Promotion">邀請碼</b-dropdown-item>-->
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="Logout">登出</b-dropdown-item>
          </b-dropdown>
          <!--<b-nav-item  class="  d-flex align-items-center "><Notice></Notice> </b-nav-item>-->
          <b-nav-item  class="px-3 d-flex align-items-center ">
            <b-img :src="require('../assets/point.png')" class="iconnotice"></b-img>
            <span v-if="points<9999999" class="text-white ml-1">{{ points }}</span>
            <span v-else class="text-white ml-1">無限點數</span>
          </b-nav-item>
        </div>
      </b-navbar-nav>
    </b-navbar>

  </div>

</template>
<style>

  .iconnotice{
    height: 25px;
  }
</style>
<script>
import {mapState} from 'vuex'
// import Notice from '@/components/Notice.vue'

export default {
  name: 'Nav',
  components: {},
  computed:{
    ...mapState(['login','profiledata']),
    isLogin:function () {
      return this.login
    },
    name:function () {return Object.keys(this.profiledata).length !== 0 ? this.profiledata.first_name+this.profiledata.last_name : '';},
    points:function () {return this.profiledata !==null ? this.profiledata.point : '0';},
    salesmodel:function () {return Object.keys(this.profiledata).length !== 0 ? (this.profiledata.salesmodel=='0'?false:true) : false;},
  },
  data () {
    return {
      show:false
    }
  },
  methods: {

    Logout(){
      this.$store.dispatch('actionLogout');
      this.show=false
      this.$router.push('/');

    },
    goTo(to){
      this.show=false
      this.$router.push('/'+to);
    }


  }
}
</script>
